import { ClearOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { FormattedMessage } from "react-intl";

import { useRouterFilter } from "../../../lib/hooks/basic/basic";
import { SidebarHeader } from "../Sidebar/Header";
import { queryFilter } from "./filter";
import { FilterPanel, type FilterProps } from "./FilterPanel";

interface FilterSidebarProps<TFilter> {
  entityName?: string;
  filters: FilterProps<TFilter>[];
  scrollToFilter?: string;
  onClose: () => void;
}

export function FilterSidebar<TFilter>({
  entityName,
  filters,
  scrollToFilter,
  onClose,
}: FilterSidebarProps<TFilter>) {
  const { router, filter } = useRouterFilter();

  // prefill with initial values from `filters` if no filters were applied
  const initialValues =
    typeof router.query.filter !== "undefined"
      ? {
          ...Object.fromEntries(
            filters.flatMap((f) =>
              f.persistDefault &&
              router.query.filter?.toString() &&
              !(f.name in filter)
                ? [[f.name, f.initialValue]]
                : []
            )
          ),
          ...filter,
        }
      : Object.fromEntries(filters.map((f) => [f.name, f.initialValue]));

  return (
    <>
      <SidebarHeader
        title={<FormattedMessage id="filters" defaultMessage="filters" />}
        back
        onClose={onClose}
        right={
          <Button
            icon={<ClearOutlined />}
            onClick={() => {
              onClose();
              router.push({
                pathname: location.pathname,
                hash: location.hash,
              });
            }}
          />
        }
      />
      <FilterPanel
        entityName={entityName}
        filters={filters}
        scrollToFilter={scrollToFilter}
        initialValues={initialValues}
        onChange={(rawFilter) => {
          const filter: any = queryFilter(rawFilter, filters).filter;
          filters.forEach((f) => {
            if (f.persistDefault && !(f.name in filter)) filter[f.name] = null;
          });

          router.push({
            pathname: router.pathname,
            hash: location.hash,
            query: {
              ...router.query,
              page: 1,
              filter:
                Object.keys(filter).length > 0 ? JSON.stringify(filter) : "",
            },
          });
        }}
      />
    </>
  );
}
